module.exports = __webpack_public_path__ + "img/5.28280d76.jpg";